// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-travel-time-__style-module___wrapper","innerWrapper":"src-components-travel-time-__style-module___innerWrapper","timeLabel":"src-components-travel-time-__style-module___timeLabel","timeValue":"src-components-travel-time-__style-module___timeValue","points":"src-components-travel-time-__style-module___points"};


//////////////////
// WEBPACK FOOTER
// ./src/components/travel-time/style.module.css
// module id = 1799
// module chunks = 0